import { render, staticRenderFns } from "./Stakeholders.vue?vue&type=template&id=9f2c08b8&"
import script from "./Stakeholders.vue?vue&type=script&lang=ts&"
export * from "./Stakeholders.vue?vue&type=script&lang=ts&"
import style0 from "./Stakeholders.vue?vue&type=style&index=0&id=9f2c08b8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports